import React from 'react'
import { Box, Text } from '@chakra-ui/react'

import { WorkflowNode } from '../node'
import { NodeProps } from '../../node-catalog'

export const ProgramStartedTrigger = ({
  config,
  hasChildren,
  isParent,
  isSelected,
  onClick
}: NodeProps) => {
  const { programName }: any = config

  let body

  if (!programName) {
    body = (
      <Box>
        <Text>Please configure this Trigger</Text>
      </Box>
    )
  } else {
    body = (
      <Box>
        <Text>
          Client starts program <Text as="b">{programName}</Text>
        </Text>
      </Box>
    )
  }

  return (
    <WorkflowNode
      heading="Program Started Trigger"
      body={body}
      isParent={isParent}
      hasChildren={hasChildren}
      isSelected={isSelected}
      onClick={onClick}
    />
  )
}
